import { InjectionToken } from '@angular/core';

/**
 * Configuration interface for the throttling interceptor
 */
export interface ThrottlingConfig {
  /** Maximum number of concurrent requests allowed */
  maxConcurrentRequests: number;
  /** Maximum number of retry attempts for 429 responses */
  maxRetries?: number;
  /** Base delay in milliseconds when no Retry-After header is present */
  baseRetryDelay?: number;
}

/**
 * Injection token for configuring the throttling interceptor
 */
export const THROTTLING_CONFIG = new InjectionToken<ThrottlingConfig>(
  'THROTTLING_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({
      maxConcurrentRequests: 6,
      maxRetries: 3,
      baseRetryDelay: 1000,
    }),
  },
);
